import { Phone, MapPin } from "lucide-react";
import { CONTACT, IMAGES } from "@/lib/menuData";

export const Hero = () => {
  return (
    <section id="top" data-testid="hero-section" className="relative border-b-2 border-[color:var(--brand-ink)]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20">
        <div className="grid lg:grid-cols-12 gap-8 items-center">
          {/* Left: text */}
          <div className="lg:col-span-7 rise-in">
            <div className="inline-flex items-center gap-2 bg-[color:var(--brand-yellow)] border-2 border-[color:var(--brand-ink)] px-3 py-1 font-bold text-xs uppercase tracking-wider shadow-brutal-sm">
              <span className="w-2 h-2 rounded-full bg-[color:var(--brand-red)] animate-pulse" />
              Now Serving • Hartford, MI
            </div>
            <h1 className="font-display mt-5 text-6xl sm:text-7xl lg:text-[8rem] leading-[0.85] uppercase">
              El
              <span className="text-[color:var(--brand-red)]"> Loco </span>
              Taco
            </h1>
            <p className="mt-5 text-lg sm:text-xl text-[color:var(--brand-ink-2)] max-w-xl">
              Authentic Mexican street food, cooked loud and proud. Tacos, tortas, quesabirrias and more — served up fresh at
              <span className="font-semibold text-[color:var(--brand-ink)]"> 309 West Main Street, Hartford, MI.</span>
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              {CONTACT.phones.map((p, i) => (
                <a
                  key={p.href}
                  href={p.href}
                  data-testid={`hero-call-${i + 1}`}
                  className="btn-brutal inline-flex items-center justify-center gap-2 bg-[color:var(--brand-red)] text-white font-bold uppercase tracking-wide px-5 py-4 border-2 border-[color:var(--brand-ink)] shadow-brutal text-base"
                >
                  <Phone size={18} strokeWidth={2.75} />
                  Call {p.display}
                </a>
              ))}
            </div>

            <a
              href="#visit"
              data-testid="hero-directions"
              className="mt-6 inline-flex items-center gap-2 text-sm font-semibold underline decoration-2 underline-offset-4 decoration-[color:var(--brand-red)] hover:text-[color:var(--brand-red)]"
            >
              <MapPin size={16} strokeWidth={2.75} /> Get directions
            </a>
          </div>

          {/* Right: image block */}
          <div className="lg:col-span-5 relative">
            <div className="relative border-2 border-[color:var(--brand-ink)] shadow-brutal-lg overflow-hidden bg-[color:var(--brand-red)] noise">
              <img
                src={IMAGES.hero}
                alt="Fresh tacos from El Loco Taco"
                className="w-full h-[360px] sm:h-[460px] lg:h-[520px] object-cover"
              />
            </div>
            <div className="absolute -bottom-4 -left-4 bg-[color:var(--brand-yellow)] border-2 border-[color:var(--brand-ink)] px-4 py-2 font-display text-2xl uppercase stamp shadow-brutal-sm">
              Hecho en Casa
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
